import { Button, Tooltip } from 'antd'
import { PropsWithChildren } from 'react'
import { useCIMSTableContext } from '../../../../CIMSTableContext'
import { DisablableHeaderActionButtonProps } from './types'

function DisablableHeaderActionButton<T extends object>({
  disabled,
  callback,
  children,
  ...rest
}: PropsWithChildren<DisablableHeaderActionButtonProps<T>>) {
  const { dataSource } = useCIMSTableContext<T>()
  const resolved =
    typeof disabled === 'function' ? disabled(dataSource) : disabled ?? false

  const button = (
    <Button
      {...rest}
      onClick={() => callback?.(dataSource)}
      disabled={resolved !== false || rest.loading}
    >
      {children}
    </Button>
  )
  return resolved !== false ? (
    <Tooltip title={resolved.message}>{button}</Tooltip>
  ) : (
    button
  )
}
export default DisablableHeaderActionButton
